import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col sm:col-3" }
const _hoisted_4 = { class: "col sm:col-9" }
const _hoisted_5 = { class: "secondary-text mobile" }
const _hoisted_6 = { class: "secondary-text desktop" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "delete-modal-content" }
const _hoisted_9 = { class: "icon-container" }
const _hoisted_10 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_FileInput = _resolveComponent("FileInput")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_FileDisplay = _resolveComponent("FileDisplay")!
  const _component_image_selector = _resolveComponent("image-selector")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "group-select col" }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "user-select col" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Select, {
        id: "edit-document-signature-required",
        name: "signature",
        label: "documents.signature-required",
        placeholder: _ctx.getPlaceholder,
        value: _ctx.model.signature?.toLowerCase(),
        items: _ctx.signatureItems,
        error: _ctx.errors.signature,
        required: "",
        onChange: _ctx.handleChange
      }, null, 8, ["placeholder", "value", "items", "error", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Select, {
        value: _ctx.model.videoType,
        error: "",
        items: _ctx.videoTypeOptions,
        label: "action.edit.type",
        name: "videoType",
        id: "videoType",
        onChange: _ctx.handleChange
      }, null, 8, ["value", "items", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.model.videoType == 'upload')
        ? (_openBlock(), _createBlock(_component_FileInput, {
            key: 0,
            acceptString: _ctx.fileUploadAccept,
            existingFile: _ctx.model.file,
            onAddFile: _ctx.handleAddFile
          }, null, 8, ["acceptString", "existingFile", "onAddFile"]))
        : (_ctx.model.videoType == 'youtube')
          ? (_openBlock(), _createBlock(_component_FormInput, {
              key: 1,
              id: "input-file-url",
              name: "fileUrl",
              label: "Input text |",
              type: "text",
              value: _ctx.model.fileUrl,
              hideLabelOnFocus: "",
              onChange: _ctx.handleChange
            }, null, 8, ["value", "onChange"]))
          : _createCommentVNode("", true)
    ]),
    (_ctx.model.fileIsLoading)
      ? (_openBlock(), _createBlock(_component_FileDisplay, {
          key: 0,
          fileName: '',
          fileType: 'video',
          isLoading: _ctx.model.fileIsLoading
        }, _createSlots({ _: 2 }, [
          (_ctx.model.fileIsLoading)
            ? {
                name: "secondaryText",
                fn: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_TranslatedText, { path: "common.processing" })
                  ]),
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_TranslatedText, { path: "common.video-processing" })
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["isLoading"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_image_selector, {
        type: "image",
        title: "Placeholder",
        placeholderImage: _ctx.model.placeholderUrl,
        previewStyle: _ctx.getPlaceholderPreviewStyle,
        onChange: _ctx.setPlaceholder
      }, null, 8, ["placeholderImage", "previewStyle", "onChange"])
    ]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.showDeleteModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showDeleteModal) = $event))
    }, {
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "delete-modal" }, null, -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_font_awesome_icon, {
              class: "icon",
              icon: "exclamation-triangle",
              size: "3x"
            })
          ]),
          _createElementVNode("h4", null, [
            _createVNode(_component_TranslatedText, { path: "prompts.warning" })
          ]),
          _createVNode(_component_TranslatedText, { path: "documents.delete-warning" })
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Button, {
            text: "common.cancel-action",
            size: "sm",
            variant: "secondary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleToggleDeleteModal()))
          }),
          _createVNode(_component_Button, {
            text: "common.delete",
            size: "sm",
            variant: "error",
            onClick: _ctx.handleDelete
          }, null, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}